<script lang="ts">
	export let active = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50.213" class:active>
	<g>
		<g>
			<path
				d="M513.782 82.191h-6.321v-3.916a4.17 4.17 0 0 0-4.17-4.17h-20.678a4.17 4.17 0 0 0-4.17 4.17v3.916h-6.321a4.174 4.174 0 0 0-4.17 4.16v33.8a4.176 4.176 0 0 0 4.17 4.17h41.66a4.17 4.17 0 0 0 4.17-4.17v-33.8a4.168 4.168 0 0 0-4.17-4.16zm2.141 37.957a2.141 2.141 0 0 1-2.141 2.141h-41.66a2.141 2.141 0 0 1-2.141-2.141v-33.8a2.139 2.139 0 0 1 2.141-2.131h7.336a1.018 1.018 0 0 0 1.015-1.015v-4.927a2.148 2.148 0 0 1 2.141-2.141h20.678a2.141 2.141 0 0 1 2.141 2.141v4.931a1.018 1.018 0 0 0 1.015 1.015h7.336a2.139 2.139 0 0 1 2.141 2.131z"
				transform="translate(-467.952 -74.105)" />
		</g>
		<g transform="translate(10.782 13.774)">
			<circle cx="14.22" cy="14.22" r="14.22" />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		&.active {
			circle,
			path {
				fill: var(--signature-blue);
			}
		}

		circle,
		path {
			transition: fill 0.5s;
			fill: #BCBFC3;
		}
	}

</style>
